import { render } from "./RemedyDatesBlock.vue?vue&type=template&id=5f08abe9&scoped=true"
import script from "./RemedyDatesBlock.vue?vue&type=script&lang=js"
export * from "./RemedyDatesBlock.vue?vue&type=script&lang=js"

import "./RemedyDatesBlock.vue?vue&type=style&index=0&id=5f08abe9&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f08abe9"]])

export default __exports__